import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import _ from 'lodash';
import DropdownList from 'react-widgets/lib/DropdownList';
import { querySelector } from '../../utils';

export class FieldDistricts extends Component {
  handleChangeDistrict(data) {
    const e = {
      target: {
        value: data.id,
      },
    };
    this.props.onSelectDistrict(e);
  }

  handleDefaultValue() {
    const { districtId, allDistricts } = this.props;
    const index = _.findIndex(allDistricts, (district) => {
      return (districtId === district.id);
    });

    return (index === -1) ? null : allDistricts[index];
  }

  render() {
    const { allDistricts } = this.props;
    return (
      <div>
        <DropdownList
          inputProps={{
            className: 'select',
          }}
          value={this.handleDefaultValue()}
          data={allDistricts}
          valueField="id"
          textField="name"
          onChange={(e) => { this.handleChangeDistrict(e); }}
        />
      </div>
    );
  }
}

FieldDistricts.propTypes = exact({
  districtId: PropTypes.number,
  onSelectDistrict: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  allDistricts: PropTypes.array.isRequired,
  /* eslint-enable react/forbid-prop-types */
});

FieldDistricts.defaultProps = {
  districtId: null,
};

export const GetAllDistrictsQuery = gql`
  query GetAllDistricts{
    all_districts {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const allDistricts = querySelector(data, '$.all_districts.edges[*].node', []);

  return {
    ...ownProps,
    allDistricts,
  };
};


const withData = graphql(GetAllDistrictsQuery, { props: marshallData });

export default withData(FieldDistricts);
